<template>
  <div class="user">
    <div class="user-center clearfix">
      <div class="fl header">
        <img v-if="userData.headImgUrl" :src="userData.headImgUrl">
        <img v-else src="../../assets/images/df_header.png">
      </div>
      <div class="fl content">
        <div class="nick-name">
          <span>{{ userData.name }}</span>
        </div>
        <div class="user-id">ID: {{ userData.name }}</div>
        <div class="more">开通会员享受更多特权</div>
      </div>
    </div>
    <div class="card-container">
      <div
        class="card-list clearfix"
        v-for="(item, index) in cardList"
        :key="index"
        @click="jumpClick(item, index)"
      >
        <div class="ico-content fl" :style="{backgroundColor: index === 0 ? '#eeb93c' : ''}">
          <img :src="item.imgSrc">
        </div>
        <div class="card-text fl">{{ item.name }}</div>
        <div class="btn-text fr">{{ item.btnText }}</div>
      </div>
    </div>
    <div class="flow-us" v-show="showFlowUs" @click.self="showFlowUs = !showFlowUs">
      <div class="container">
        <div style="margin-bottom: 15px;">长按二维码关注公众号</div>
        <div>体验最强智能聊天机器人</div>
        <div class="public-code">
          <img src="../../assets/images/user/gzh.jpg">
        </div>
        <div class="tips">长按二维码识别关注公众号</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'User',
    data() {
      return {
        showFlowUs: false,
        userData: {},
        cardList: [
          { name: '开通会员畅想无限对话', imgSrc: require('../../assets/images/user/member.png'), btnText: ''},
          { name: '关注公众号防走丢', imgSrc: require('../../assets/images/user/flow.png'), btnText: '去关注'},
          { name: '联系客服', imgSrc: require('../../assets/images/user/kf.png'), btnText: ''},
          { name: '关于我们', imgSrc: require('../../assets/images/user/abs.png'), btnText: ''},
        ]
      }
    },
    created() {
      this.getUserInfo()
    },
    methods: {
      async getUserInfo() {
        let data = await $api.getPanel()
        if (data) {
          this.userData = data || {}
          console.log(this.userData);
        }
      },
      jumpClick(data, index) {
        if (index === 0) {
          this.$notify({ type: 'success', message: '功能开发中' })
        }
        if (index === 1) {
          this.showFlowUs = true
        }
        if (index === 2) {
          this.$notify({ type: 'success', message: '功能开发中' })
        }
        if (index === 3) {
          this.$router.push({ path: '/aboutUs' })
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .user{
    font-size: 12px;
    width: 100%;
    height: calc(100% - 40px - env(safe-area-inset-bottom));
    position: relative;
    background-color: #f8f8f8;
    .clearfix {
      zoom: 1;
      &:before,
      &::after {
        display: table;
        content: ' ';
      }
      &::after {
        clear: both;
        height: 0;
        font-size: 0;
        visibility: hidden;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
    .user-center{
      background-color: #FFFFFF;
      padding: 15px 15px 10px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .header{
        width: 60px;
        height: 60px;
        margin-right: 10px;
        border-radius: 50%;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .content{
        div{
          margin-bottom: 5px;
        }
        .nick-name{
          font-size: 22px;
          font-weight: bold;
        }
        .user-id{}
        .more{
          color: #cccccc;
        }
      }
    }
    .card-container{
      padding: 0 15px;
      box-sizing: border-box;
      .card-list{
        margin-bottom: 15px;
        background-color: #FFFFFF;
        padding: 10px 15px;
        border-radius: 5px;
        .ico-content,.card-text,.btn-text{
          vertical-align: middle;
          line-height: 30px;
        }
        .ico-content{
          width: 30px;
          height: 30px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          background-color: @colorDefault;
          img{
            width: 75%;
            height: 75%;
          }
        }
        .card-text{
          font-size: 14px;
        }
        .btn-text{
          color: @colorDefault;
          border-radius: 6px;
          padding: 0 10px;
          background-color: #f5f6fa;
        }
      }
    }
    .flow-us{
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 199;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      .container{
        background-color: #ffffff;
        width: 60%;
        height: 260px;
        border-radius: 15px;
        padding: 15px;
        text-align: center;
        div{
          font-weight: bold;
        }
        div.public-code{
          height: 200px;
          margin-bottom: 0;
          img{
            height: 100%;
          }
        }
        div.tips{
          font-size: 10px;
          font-weight: normal;
          color: #ccc;
        }
      }
    }
  }
</style>
